import React from "react";
import NnAudioElement from "./NnAudioElement";
import Note from "./Note";

class NnNote extends React.Component {
  // constructor(props) {
  // super(props);
  // }

  render() {
    return (
      <li className="noteAndLyric">
        <div className="note">
          {this.props.note.display}
          <span className="note-time">/{this.props.note.displayDuration}</span>
        </div>
        <div className="lyric">{this.props.note.lyric}</div>
      </li>
    );
  }
}

export default NnNote;



// WEBPACK FOOTER //
// ./src/NnNote.js